$(document).ready(function(){
// $(".link_tocollection").on("click",function(e){
//   e.preventDefault();
//   var id= $(this).attr("data-id");
//   var data_url=$(this).attr("data-url");
//   console.log(id,data_url);
//   window.location.href = data_url+"?"+id;
// });
  
  $(".link_tocollectiongift.linkForGift .overlaytoGift").on("click",function(e){
    $('.GiftPopUp').show();
    $('body').addClass('giftPopUpView');
  });
  
  $('.notwilling-gift, .giftPopUpView').on("click",function(e){
    $('.GiftPopUp').hide();
    $('body').removeClass('giftPopUpView');
    $(".link_tocollectiongift").removeClass('linkForGift');
  });
 /* Get url on page load */
  
 var url=window.location.href;
  var parts = url.split("?");
 var last_part = parts[parts.length-1];
  console.log(last_part, "lastpart");
  if (window.location.href.indexOf("?") > -1) {
     $(".hidden_query").val(last_part);
    }

  
  
  /* collection page link */
  $(".collection_link").on("click",function(e){
    e.preventDefault();
    
    var hidden_query=$(".hidden_query").val();
    var data_href=$(this).attr("href");
    console.log(data_href,hidden_query)
    
    if(hidden_query != ''){
      window.location.href = data_href+"?"+hidden_query;
     
    }
    else{
   window.location.href = data_href;

       console.log("Not value");
      
    }
    
   }); 
  

  
});